import { render } from "./adminsublist3.vue?vue&type=template&id=38fa8fba&scoped=true&ts=true"
import script from "./adminsublist3.vue?vue&type=script&lang=ts"
export * from "./adminsublist3.vue?vue&type=script&lang=ts"

import "./adminsublist3.vue?vue&type=style&index=0&id=38fa8fba&lang=scss&scoped=true"
import "./adminsublist3.vue?vue&type=style&index=1&id=38fa8fba&lang=scss"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fa8fba"]])

export default __exports__